import router from '../../router';

export default () => {
    if (router.app.$refs.progressBar) {
        router.app.$refs.progressBar.stopRouting();
    }
};




// WEBPACK FOOTER //
// ./resources/js/middleware/after/progressBar.js